export const environment = {
  production: true,
  clientIdGateway: 'ddcab6bd-2cd8-4f18-811d-18b2cd0c1351',
  redirectURL: 'https://app-staging.cadostore.com/',
  localApi: false,
  authentication: true,
  versionApi: 'v1',
  urlSiteVitrine: 'https://cadostore.front.staging.cloud.bimpli.com/',
  urlComiteo: 'https://e.cadostore.com/sso',
  googleCaptchaPublicKey: '6LdVAiMiAAAAABG2s_NRkh9K9FU5Q4qQuT73gTSz',
  environment: 'QUA',
  applicationId: 'SiteCadoStore',
  pageSizeVar: '10',
  icVersion: '10906380462',
  icScmBranch: 'staging',
  icScmTag: '13/merge',
  switchPayPlug: '1',
  urlWebFinanceur: 'https://entreprise.bimpli-preprod.com/',
  gtmId: 'GTM-NKNVC73J',
  urlWebBeneficiaire: 'https://collaborateur.bimpli-preprod.com/',
};
